<svelte:options accessors/>
<script>
    import {createEventDispatcher, onMount} from 'svelte';
    import Pagination from "./Pagination.svelte";
    import {getProductImage} from "../utils";
    import Filters from "./Filters.svelte";

    export let products;
    export let pagination;
    export let groupsData;
    export let brandsData;
    export let linesData;
    export let countriesData;

    export let group = '';

    let groupName = '';
    export let loading = false;
    let prefetch = true;

    let dispatch = createEventDispatcher();
    let tree = [];
    let brands = [];
    let lines = [];
    let countries = [];

    let filtersCmp;

    let term = '';

    onMount(() => {
        const params = new URLSearchParams(window.location.search);
        if (params.get('page')) {
            pagination.page = +params.get('page');
        }
        if (params.get('search')) {
            term = params.get('search');
        }

        for (const gData of groupsData) {
            const g = {
                name: gData.Nombre,
                slug: gData.Slug,
                enabled: false,
                options: []
            };
            for (const cData of gData.Categorias) {
                const c = {
                    name: cData.Nombre,
                    slug: cData.Slug,
                    enabled: false,
                    options: []
                };
                g.options.push(c);
                for (const sData of cData.Subcategorias) {
                    const s = {
                        name: sData.Nombre,
                        slug: sData.Slug,
                        enabled: false,
                        options: []
                    }
                    c.options.push(s);
                }
            }
            tree = [...tree, g];
        }
        if (group) {
            groupName = tree.find(g => g.slug === group).name;
        }
        for (const bData of brandsData) {
            brands.push({slug: bData.Value, name: bData.Label});
        }
        for (const lData of linesData) {
            lines.push({slug: lData.Value, name: lData.Label});
        }
        for (const cData of countriesData) {
            countries.push({slug: cData.Value, name: cData.Label});
        }
        prefetch = false;
    });

    function setProducts(ev) {
        const data = ev.detail;
        console.log(data);
        if (data.term) {
            products = ev.detail.filtered;
            pagination = {
                total: ev.detail.count,
                page: term === data.term ? pagination.page : 1
            };
            term = data.term;

            const params = new URLSearchParams();
            products = data.filtered;
            //dispatch('filter', params);
        } else {
            term = '';
            pagination.page = 1;
            filtersCmp.applyFilters();
        }
    }

    function checkPagination(ev) {
        if (term) {
            pagination.page = ev.detail;
            filtersCmp.getSearchNext(pagination.page);
        } else {
            dispatch('next', ev.detail);
        }
    }

    function clearSearch() {
        term = '';
        pagination.page = 1;
        filtersCmp.applyFilters();
    }

    function getProductUrl(product) {
        let groupSlug = null;
        if (product.ProductoGrupos && product.ProductoGrupos.length > 0) {
            groupSlug = product.ProductoGrupos[0].Grupo.Slug;
        }

        if (groupSlug) {
            return `/productos/${groupSlug}/${product.Slug}`;
        } else {
            return `/productos/producto/${product.Slug}`;
        }
    }
</script>

<ul class="breadcrump">
    <li><a href="/">Inicio</a></li>
    <li><a href="/productos">Productos</a></li>
    {#if group}
        <li><a href="/{group}">{groupName}</a></li>
    {/if}
</ul>
<div class="products-container">
    {#if !prefetch}
    <Filters {countries} {brands} {lines}
             bind:this={filtersCmp}
             bind:activeGroup={group}
             on:filter
             on:group
             on:clear={clearSearch}
             on:search={setProducts}
             bind:tree={tree}/>
    {/if}
    <div class="boxright">
        <h1>Productos</h1>
        {#if loading}
            <div class="text-center">
                <small>Cargando...</small>
            </div>
        {:else}
            {#if products.length === 0}
                <div>No se han encontrado productos con los filtros seleccionados.</div>
            {/if}
            <div class="productsgrid">
                {#each products as product}
                    <div class="productsingle">
                        <a href={getProductUrl(product)}>
                            <img src="{getProductImage(product)}" alt="">
                            <div class="productName">
                                <p>{product.Nombre}</p>
                                <div class="filing">
                                    <span>Ver presentaciones &#62;</span>
                                </div>
                            </div>
                        </a>
                    </div>
                {/each}
            </div>
            <Pagination bind:data={pagination} on:next={checkPagination}/>
        {/if}
    </div>
</div>

